import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { AuthShell } from "@/components/layouts/auth-shell"
import { GoogleSignInButton } from "@/components/features/auth/google-sign-in-button"
import { useForm, usePage, Link } from "@inertiajs/react"
import { FormEvent } from "react"
import { t } from "@/lib/i18n"
export default function StaffSessionsNew() {
    const { flash = {} } = usePage<{
        flash: {
            alert?: string
            notice?: string
        }
    }>().props
    const { data, setData, post } = useForm({
        email_address: "",
        password: "",
    })
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        post("/session")
    }
    return (<AuthShell title={t("ui.auth.titles.staff_sign_in")} headline={t("ui.auth.staff.headline")} blurb={t("ui.auth.staff.blurb")}>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight">{t("ui.react.pages.staff.sessions.new.welcome_new")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("ui.react.pages.staff.sessions.new.sign_session_manage_restaurants")}</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          {flash.alert && (<div className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
              {flash.alert}
            </div>)}
          {flash.notice && (<div className="rounded-md border border-success/40 bg-success/10 p-3 text-sm text-success" data-testid="session-notice">
              {flash.notice}
            </div>)}
          <div className="grid gap-2">
            <Label htmlFor="email_address">{t("ui.react.pages.staff.sessions.new.email")}</Label>
            <Input id="email_address" type="email" placeholder={t("ui.react.pages.staff.sessions.new.m_ejemplo_com")} value={data.email_address} onChange={(e) => setData("email_address", e.target.value)} required/>
          </div>
          <div className="grid gap-2">
            <div className="flex items-center">
              <Label htmlFor="password">{t("ui.react.pages.staff.sessions.new.password")}</Label>
              <Link href="/passwords/new" className="ml-auto text-sm underline-offset-4 hover:underline" data-testid="forgot-password-link">{t("ui.react.pages.staff.sessions.new.forgot_password")}</Link>
            </div>
            <Input id="password" type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} required/>
          </div>
          <Button type="submit" className="w-full">{t("ui.react.pages.staff.sessions.new.start_session")}</Button>
          <GoogleSignInButton label={t("ui.react.pages.staff.sessions.new.continue_with_google")}/>
          <div className="text-center text-sm">{t("ui.react.pages.staff.sessions.new.no_tienes_bill")}{" "}
            <Link href="/registration/new" className="underline underline-offset-4">{t("ui.react.pages.staff.sessions.new.register")}</Link>
          </div>
        </div>
      </form>
    </AuthShell>)
}
